import SettlementSalesActions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperSettlementSales:[],
  errorInternal:false,
  printSettlementSales:null,
};

function SettlementSalesReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SettlementSalesActions.RESET_LIST:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,data:{}};
    case SettlementSalesActions.NEW_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, errorMessage:[],form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case SettlementSalesActions.UPDATE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:null,isNewRecord:false};
    case SettlementSalesActions.VIEW_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:action.payload,errorMessage:[],isNewRecord:false,showModal:true};
    case SettlementSalesActions.RESET_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case SettlementSalesActions.DELETE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case SettlementSalesActions.ON_SUBMIT:
      return { ...state, errorInternal:false,onSubmit:true};
    case SettlementSalesActions.SHOW_DATA:
      return { ...state, errorInternal:false,onSubmit:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case SettlementSalesActions.ERROR_DATA:
      return { ...state, errorInternal:false, isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case SettlementSalesActions.SUCCESS_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case SettlementSalesActions.PROCESS_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: true, isError: false,isSuccess:false};
    case SettlementSalesActions.GET_HELPER_CASHFLOW:
      return { ...state,errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperSettlementSales:action.payload};
    case SettlementSalesActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
    case SettlementSalesActions.BEFORE_PRINT_CASHFLOW:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printSettlementSales:null,isProcessing:true};
    case SettlementSalesActions.PRINT_CASHFLOW:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printSettlementSales:action.payload,isProcessing:false};
       
    default:
      return state;
    }
}

export default SettlementSalesReducer;
